export default {
  appTitle: 'LoanKnow - Local',
  apiUrl: 'https://localhost:8015/api',
  appEnv: 'development',
  isDevelopment: true,
  isStaging: false,
  isProduction: false,
};